var React = require('react');

function BlueRectangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.548.097h75.237a3 3 0 0 1 3 3v28.366a3 3 0 0 1-3 3H2.987a2.44 2.44 0 0 1-1.718-.707 2.41 2.41 0 0 1-.712-1.708V.106z","fill":"#3181ff"}));
}

BlueRectangle.defaultProps = {"width":"79","height":"35","fill":"none"};

module.exports = BlueRectangle;

BlueRectangle.default = BlueRectangle;
